/* eslint-disable */
import React from 'react';
import { Badge } from 'antd';

import {
    CardDescription,
    CardTitle,
    CardsGrid,
    DictionaryItem,
    typeLabels,
} from '../styles';

function DictionaryCardsGrid({ dictionaries, onSelect, showIntegrationKey = false }) {
    return (
        <CardsGrid>
            {dictionaries.map((dict) => (
                <Badge.Ribbon
                    key={dict.id}
                    text={typeLabels[dict.type]?.text || dict.type}
                    color={typeLabels[dict.type]?.color || 'default'}
                >
                    <DictionaryItem onClick={() => onSelect(dict)}>
                        <CardTitle>{dict.name}</CardTitle>
                        {dict.description && (
                            <CardDescription>{dict.description}</CardDescription>
                        )}
                        {showIntegrationKey && dict.external_integration_key && (
                            <div style={{ fontSize: '12px', color: '#1890ff', marginTop: 8 }}>
                                Ключ:
                                {' '}
                                {dict.external_integration_key}
                            </div>
                        )}
                    </DictionaryItem>
                </Badge.Ribbon>
            ))}
        </CardsGrid>
    );
}

export default DictionaryCardsGrid;
